import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import NetlifyForm from 'react-netlify-form'

import Button from '../button'

export default ({ children }) => (

    <NetlifyForm name='Contact Form'>
    {({ loading, error, success }) => (
        <Style>
          {loading &&
            <div>Loading...</div>
          }
          {error &&
            <div>Your information was not sent. Please try again later.</div>
          }
          {success &&
            <div>Thank you for contacting us!</div>
          }
          {!loading && !success &&
            <React.Fragment>
                <legend>Request a demo <small>&hellip;and see the power of UserCity for yourself.</small></legend>
            
                <div className="fieldset">
                
                    <input type="text" name="name" placeholder="Your name" />
                    <input type="email" name="email" placeholder="Your email" />
                    <Button type="submit" primary>Send request</Button>
                </div>
        </React.Fragment>
          }
    </Style>
    )}
    </NetlifyForm>
)


const Style = styled.div.attrs(props => ({

}))`
    color: var(--white);

    > legend {
        font-weight: 800;
        text-align: center;
        display: flex;
        flex-direction: column;
        margin: 0;
        width: 100%;
        font-size: 6vmax;
        line-height: 0.93;
        letter-spacing: -.0375em;

        > small {
            display: block;
            font-size: 4.25vmax;
            letter-spacing: -1.12px;
            font-weight: 600;
            margin-top: .25em;
        }

        ${breakpoint('desktop')`
            font-size: 72px;

            > small {
                font-size: 32px;
            }
        `}
    }

    .fieldset {
        border: none;
        margin: 2em 0 0 0;
        padding: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;

        ${breakpoint('tablet')`
            flex-direction: row;
        `}

        > * {
            margin: .65em 0;

            ${breakpoint('tablet')`
                margin: 0 .65em;
            `}
        }

        input {
            padding: .15em .5em;
            min-height: 22px;
            line-height: 24px;
            appearance: none;
            outline: none;
            border: 2px var(--white) solid;

            &:focus {
                border-color: var(--red);
            }
        }
    }
`